/* eslint-disable-next-line  no-unused-vars */
import React, { createElement, useEffect, useState, useContext } from 'react';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.min.css';
import './ShowMessage.scss';
import { Alert, Slide, Snackbar } from '@mui/material';
import { MapContext } from './MapContextProvider';

export default function ShowMessageComponent({ customMessages }) {
    const { messages } = useContext(MapContext);
    const [messageText, setMessageText] = useState();
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (customMessages) {
            showNotification(customMessages);
        }
    }, [customMessages]);

    // useEffect(() => {
    //     console.log(messageRef);
    // }, [messageRef.current]);

    useEffect(() => {


        if (typeof messages === 'string' || messages instanceof String) {
            setMessageText(messages);
            setOpen(true);
        } else if (Array.isArray(messages)) {
            showNotification(messages);
        }
    }, [messages]);

    const showNotification = (itemList) => {
        if (itemList.length == 0) {
            return;
        }
        let messageResult = itemList.map((item, index) => {
            return <div key={index}>{item}</div>;
        });

        setMessageText(messageResult);

        setOpen(true);
    };

    const MyComponent = (messageArray) => {
        return (
            <div className="notificationMessage">
                {messageArray.map((item, index) => {
                    return <div key={index}>{item}</div>;
                })}
            </div>
        );
    };

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    };

    function SlideTransition(props) {
        return <Slide {...props} direction="up" mountOnEnter unmountOnExit style={{ transitionDelay: '1000ms' }} />;
    }

    return (
        <>
            {/* <ToastContainer limit={5} /> */}

            <Snackbar
                open={open}
                autoHideDuration={6000}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                TransitionComponent={SlideTransition}
            >
                <Alert onClose={handleClose} severity="success">
                    {messageText}
                </Alert>
            </Snackbar>
        </>
    );
}
